// The address bar always shows what is on screen (2026-10-19), so a refresh
// lands exactly where the person was. A closed contact used to keep
// /contact/<n> in the URL, and a refresh reopened it.
//
// The path for a view:
//   - /contact/<n> when a contact is the primary selection on the queue page;
//   - /tasks on the Tasks page; /parked on the Parked page when the URL is
//     already /parked (its deep link), as before;
//   - '/' otherwise (the queue with nothing open, Settings, Ops, Audit,
//     Reporting, ...). The last page itself still comes from localStorage on
//     load.
import { convNumberPath } from './contactPath.js'
import { TASKS_PATH } from './tasks.js'
import { isParkedPath } from './parking.js'

export function viewPath({ page, convNumber = null, currentPath = '/' }) {
  if (page === 'queue') return convNumber != null ? convNumberPath(convNumber) : '/'
  if (page === 'tasks') return TASKS_PATH
  if (page === 'parked' && isParkedPath(currentPath)) return currentPath
  return '/'
}
